<groundworks-modal data-testid="ppj-exception-modal">
  <groundworks-modal-header [title]="title()" [isCancellable]="true" (cancelModal)="cancel()" />
  <groundworks-modal-body>
    <form [formGroup]="form" (ngSubmit)="submit()">
      <div class="mb-2">
        <label for="ppj-exception-person" class="form-label">Person</label>
        <!-- R14/T9 — the two empty cases are indistinguishable by list length, so each states its own
             fact. The picker also renders in edit mode, disabled, so the row's person stays visible. -->
        @if (isEdit() || hasEligiblePeople()) {
          <ng-select
            inputId="ppj-exception-person"
            data-testid="ppj-exception-person-picker"
            [items]="pickerItems()"
            bindLabel="label"
            bindValue="id"
            [groupBy]="ppjGroupLabel"
            placeholder="Select a person"
            formControlName="userId">
          </ng-select>
        } @else if (peopleError()) {
          <p class="text-danger mb-0" data-testid="ppj-exception-people-error">
            Could not load the people eligible for a PPJ exception. Please try again.
          </p>
        } @else if (hasBranch()) {
          <p class="text-muted mb-0" data-testid="ppj-exception-no-people-message">
            Nobody at this job's branch is eligible for a PPJ exception.
          </p>
        } @else {
          <p class="text-muted mb-0" data-testid="ppj-exception-no-branch-message">
            This job has no branch, so there is nobody to choose from.
          </p>
        }
      </div>
      <div class="mb-2">
        <label for="ppj-exception-amount" class="form-label">Amount</label>
        <div class="input-group">
          <span class="input-group-text">$</span>
          <input id="ppj-exception-amount" type="number" step="0.01" class="form-control"
            data-testid="ppj-exception-amount" formControlName="amount" />
        </div>
      </div>
      <div class="mb-2">
        <label for="ppj-exception-date-qualified" class="form-label">Date Qualified</label>
        <input id="ppj-exception-date-qualified" type="date" class="form-control"
          data-testid="ppj-exception-date-qualified" formControlName="dateQualified" />
      </div>
      <div class="mb-2">
        <label for="ppj-exception-note" class="form-label">Note</label>
        <textarea id="ppj-exception-note" class="form-control" data-testid="ppj-exception-note"
          formControlName="note"></textarea>
      </div>
      @if (errorMessage()) {
        <p class="text-danger" data-testid="ppj-exception-error">{{ errorMessage() }}</p>
      }
    </form>
  </groundworks-modal-body>
  <groundworks-modal-footer [actions]="footerActions()" />
</groundworks-modal>
